import React, { Suspense } from "react";
import "./App.css";
import UpdateBanner from "./components/UpdateBanner";
import DesktopApp from "./app/DesktopApp";
import { IS_DESKTOP } from "./config";

// Web routes are lazy so they land in a separate chunk the desktop build never
// downloads. (When REACT_APP_BUILD_TARGET=desktop, IS_DESKTOP is statically
// true and this import is never reached at runtime.)
const WebApp = React.lazy(() => import("./web/WebApp"));

const App: React.FC = () => {
  // Desktop: document-centric shell, no web routes/marketing chrome.
  if (IS_DESKTOP) {
    return (
      <>
        <UpdateBanner />
        <DesktopApp />
      </>
    );
  }

  // Web: marketing + route-driven tool suite.
  return (
    <Suspense fallback={null}>
      <UpdateBanner />
      <WebApp />
    </Suspense>
  );
};

export default App;
